import { useState } from 'react';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';
import ContactModal from '@/components/feature/ContactModal';

export default function SolutionsHero() {
  const [showConsultModal, setShowConsultModal] = useState(false);

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${img('readdy/f15eb1c909793c179c1def5b5adffa90.png')})`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-black/45 via-black/25 to-black/35" />

      <div className="relative z-10 w-full h-full flex items-center px-6 md:px-10">
        <div className="max-w-7xl mx-auto w-full">
          <ScrollReveal variant="fade-right">
            <p className="text-brand-gold text-sm tracking-widest mb-4 font-medium">
              健康纤体方案
            </p>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4 max-w-lg">
              个性化健康纤体
              <br />
              解决方案
            </h1>
            <p className="text-white/65 text-sm md:text-base leading-relaxed mb-8 max-w-md">
              以"绿色、高效、无忧"为核心理念，融合中医经络理论参考与现代健康管理科学，
              每一位顾客都能获得适合自己的专属方案。
            </p>
            <button
              onClick={() => setShowConsultModal(true)}
              className="inline-flex items-center gap-2 px-9 py-3.5 bg-brand-deep text-white text-sm font-medium rounded-full hover:bg-brand-dark transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              预约专属顾问
              <i className="ri-arrow-right-line" />
            </button>
          </ScrollReveal>
        </div>
      </div>

      <ContactModal
        open={showConsultModal}
        onClose={() => setShowConsultModal(false)}
        type="consultation"
      />
    </section>
  );
}